import axios from "axios";
import {
  authHeader,
  handleResult,
  handleException,
  globalStore
} from "../helpers";

export const userService = {
  login,
  loginExternal,
  refreshUserAndToken,
  get,
  getById,
  saveUser,
  changePassword,
  deleteUser
};

function login(username, password) {
  return axios
    .post("users/authenticate/", {
      username: username,
      password: password
    })
    .then(result => {
      if (result.data.token) {
        localStorage.setItem("user", JSON.stringify(result.data));
      }
      globalStore.loginState.init();
      return result.data;
    })
    .catch(handleException);
}

function refreshUserAndToken() {
  const requestOptions = {
    headers: authHeader()
  };
  
  return axios
  .get("users/authenticate/refresh", requestOptions)
  .then(result => {
    if (result.data.token) {
      localStorage.setItem("user", JSON.stringify(result.data));
    }
    globalStore.loginState.init();
    return result.data;
  })
  .catch(handleException);
}

function loginExternal(token) {
  return axios
    .post("users/authenticateExternal/", {
      Token: token
    })
    .then(result => {
      if (result.data.token) {
        localStorage.setItem("user", JSON.stringify(result.data));
      }
      globalStore.loginState.init();
      return result.data;
    })
    .catch(handleException);
}

function get() {
  if (globalStore.users) {
    console.log("Users exists in cache");
    return new Promise(resolve => resolve(globalStore.users));
  }
  console.log("No global store for users, calling api");

  const requestOptions = {
    headers: authHeader()
  };

  return axios
    .get("users", requestOptions)
    .then(handleResult)
    .then(p => {
      globalStore.users = p;
      return p;
    })
    .catch(handleException);
}

function getById(userId) {
  const requestOptions = {
    headers: authHeader()
  };
  return axios
    .get(`users/${userId}`, requestOptions)
    .then(handleResult)
    .catch(handleException);
}

function saveUser(user) {
  const requestOptions = {
    headers: authHeader()
  };

  if (!user.id || user.id == 0) {
    return axios
      .post("users", user, requestOptions)
      .then(handleResult)
      .catch(handleException);
  }

  return axios
    .patch("users/" + user.id, user, requestOptions)
    .then(handleResult)
    .catch(handleException);
}

function changePassword(userId, newPassword, confirmedPassword) {
  const requestOptions = {
    headers: authHeader()
  };
  return axios
    .patch(
      "users/" + userId + "/changepassword",
      { newPassword, confirmedPassword },
      requestOptions
    )
    .then(handleResult)
    .catch(handleException);
}

function deleteUser(userId) {
  const requestOptions = {
    headers: authHeader()
  };
  return axios
    .delete(`users/${userId}`, requestOptions)
    .then(handleResult)
    .catch(handleException);
}
